export class ShortcutController {
  constructor(game) {
    this._game = game;
    this._sceneController = game.sceneController;
    this._setShortcuts();
  }

  // shortcuts
  _setShortcuts() {
    if (!__SHORTCUTS_ENABLED__) return;

    this._game.shortcuts.reset();
    this._game.shortcuts.addShortcutGroup({ title: 'Game', open: true });

    this._game.shortcuts.addShortcut({
      id: 'deletedata',
      title: 'Delete Data',
      value: () => {
        localStorage.clear();
        window.location.reload();
      },
    });
    this._game.shortcuts.addToggle({
      field: 'allowLevelSelect',
      title: 'Allow level select',
      value: this._game.allowLevelSelect,
      onChange: (e) => (this._game.allowLevelSelect = e),
    });
    this._game.shortcuts.addToggle({
      field: 'allowSkipping',
      title: 'Allow skipping',
      value: this._game.allowSkipping,
      onChange: (e) => (this._game.allowSkipping = e),
    });
    this._game.shortcuts.addShortcut({
      id: 'givebpp',
      title: 'Give 1000 BPP',
      value: () => {
        if (this._game.model) {
          this._game.model.addBPP(1000);
        }
      },
    });
  }
}
